$(function(){
	$('.story_navi a[href^="#"] ,.color a[href^="#"]').click(function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 100;
	 	$("html, body").animate({scrollTop:position}, 550, "swing");
	    return false;
	});
ScrollTrigger.matchMedia({
	
  // 768px以上
  "(min-width: 768px)": function() {
		gsap.utils.toArray('.js-trigger-img01').forEach(wrap => {
		  const y = wrap.getAttribute('data-y') || -150;
		  gsap.to(wrap, {
		    y: y,    
		    scrollTrigger: {
		      trigger: wrap,
		      start: 'top bottom',
		      end: 'bottom top',
		      scrub: 2
		    }
		  })
		});
		gsap.utils.toArray('.js-trigger-txt').forEach(wrap => {
		  const y = wrap.getAttribute('data-y') || -230;
		  
		  gsap.to(wrap, {
		    y: y,    
		    scrollTrigger: {
		      trigger: wrap,
		      start: 'top bottom',
		      end: 'bottom top',
		      scrub: 1
		    }
		  })
		});
		gsap.utils.toArray('.js-trigger-img02').forEach(wrap => {
		  const y = wrap.getAttribute('data-y') || -260;
		  
		  gsap.to(wrap, {
		    y: y,    
		    scrollTrigger: {
		      trigger: wrap,
		      start: 'top bottom',
		      end: 'bottom top',
		      scrub: 2
		    }
		  })
		});
		//ナビ固定
		gsap.to('.story_navi', {
		  scrollTrigger: {
		    trigger: '.story_navi',
			start: 'bottom 100%',
			end: 'bottom 100%',
		    endTrigger: '.story_inner',
		    pin: true,  
		    //markers: true
		  }
		});

  },
  // 767px以下
  "(max-width: 767px)": function() {
		gsap.utils.toArray('.js-trigger-img01').forEach(wrap => {
		  const y = wrap.getAttribute('data-y') || -60;
		  gsap.to(wrap, {
		    y: y,    
		    scrollTrigger: {
		      trigger: wrap,
		      start: 'top bottom',
		      end: 'bottom top',
		      scrub: 0.5
		    }
		  })
		});

		gsap.utils.toArray('.js-trigger-txt').forEach(wrap => {
		  const y = wrap.getAttribute('data-y') || -100;
		  
		  gsap.to(wrap, {
		    y: y,    
		    scrollTrigger: {
		      trigger: wrap,
		      start: 'top bottom',
		      end: 'bottom top',
		      scrub: 0.8
		    }
		  })
		});
		gsap.utils.toArray('.js-trigger-img02').forEach(wrap => {
		  const y = wrap.getAttribute('data-y') || -80;
		  
		  gsap.to(wrap, {
		    y: y,    
		    scrollTrigger: {
		      trigger: wrap,
		      start: 'top bottom',
		      end: 'bottom top',
		      scrub: 0.6
		    }
		  })
		});

  }

}); 

	
	
	gsap.utils.toArray('.js-trigger-txt .code').forEach(wrap => {
	  gsap.to(wrap, {
		backgroundPosition: "65% 100%",
		ease: "none",
	    scrollTrigger: {
	      trigger: wrap,
	      start: 'top bottom',
	      end: 'bottom top',
	      scrub: 0.5,
	    }
	  })
	});
	

	//波固定
	gsap.to('.story_canvas', {
	  scrollTrigger: {
	    trigger: '.story_canvas',
		start: 'bottom 100%',
		end: 'bottom+=300 100%',
	    endTrigger: '.story',
	    pin: true,  
	    //markers: true
	  }
	});

	//ナビゲーションの動き
	var array = ['cee','bec','4dc','3b8','fff','fee	','ed4','a24','c84','a65','864','621'];
	let sectionItem
	let navItem

	$.each(array, function(index, value) {
	  navItem = '#navi_' + value
	  sectionItem = '#story_' + value
	  ScrollTrigger.create({
	    trigger: sectionItem,
	    start: 'top center',
	    end: 'bottom center',
	    toggleClass: {
	      targets: navItem,
	      className: 'is-active',
	    },
		onToggle: (self) => {
			var scrollwidth = 0;
			for (let i = 1; i <= index; i++) {
				scrollwidth = scrollwidth + $(".story_navi li").eq(i).outerWidth(true);
			}				
			if(self.isActive){
				//var scrollwidth = $('#navi_' + value).position().left;
				$('.story_navi').animate({
					scrollLeft:scrollwidth
				}, 300, 'swing');
			}
			
		},
		
	  }) 
	})
	$('.story_navi').scroll(function () {
	  const el = $(this).scrollLeft();
	  
	  var boxWidth = this.offsetWidth;
	  var range = this.scrollWidth - this.offsetWidth;
	  
	  if (el == range || el > range) {
		$(".scroller-arrow").css({
		"display": "none",
		"right": - el
		});
	  }
	  else{
		$(".scroller-arrow").css({
		"display": "block",
		"right": - el
		});
	  }

	});
});